// Main class for Actor, all actors will extend this class
// used for common behaviours to actors

class Actor {
  constructor(parent) {
    this.parent = parent;
    this.sprite = null;
  }
}

export default Actor;
